module.exports = __webpack_public_path__ + "img/asteroid4.dd461ffb.jpg";